import {
  AT,
  BE,
  BG,
  CY,
  CZ,
  DE,
  DK,
  EE,
  ES,
  FI,
  FR,
  GR,
  HR,
  HU,
  IE,
  IT,
  LT,
  LU,
  LV,
  MT,
  NL,
  PL,
  PT,
  RO,
  SE,
  SI,
  SK,
} from 'country-flag-icons/react/3x2';

// eslint-disable-next-line max-len
export const taxRegexp = /^((AT)(U\d{8})|(BE)(0\d{9})|(BG)(\d{9,10})|(CY)(\d{8}[LX])|(CZ)(\d{8,10})|(DE)(\d{9})|(DK)(\d{8})|(EE)(\d{9})|(EL|GR)(\d{9})|(ES)([\dA-Z]\d{7}[\dA-Z])|(FI)(\d{8})|(FR)([\dA-Z]{2}\d{9})|(HU)(\d{8})|(IE)(\d{7}[A-Z]{2})|(IT)(\d{11})|(LT)(\d{9}|\d{12})|(LU)(\d{8})|(LV)(\d{11})|(MT)(\d{8})|(NL)(\d{9}(B\d{2}|BO2))|(PL)(\d{10})|(PT)(\d{9})|(RO)(\d{2,10})|(SE)(\d{12})|(SI)(\d{8})|(SK)(\d{10}))$/;

export const countryData = Object.freeze({
  AT: {
    component: AT,
    code: '43',
    prefix: 'AT',
  },
  BE: {
    component: BE,
    code: '32',
    prefix: 'BE',
  },
  BG: {
    component: BG,
    code: '359',
    prefix: 'BG',
  },
  CY: {
    component: CY,
    code: '357',
    prefix: 'CY',
  },
  CZ: {
    component: CZ,
    code: '420',
    prefix: 'CZ',
  },
  DE: {
    component: DE,
    code: '49',
    prefix: 'DE',
  },
  DK: {
    component: DK,
    code: '45',
    prefix: 'DK',
  },
  EE: {
    component: EE,
    code: '372',
    prefix: 'EE',
  },
  ES: {
    component: ES,
    code: '34',
    prefix: 'ES',
  },
  FI: {
    component: FI,
    code: '358',
    prefix: 'FI',
  },
  FR: {
    component: FR,
    code: '33',
    prefix: 'FR',
  },
  GR: {
    component: GR,
    code: '30',
    prefix: 'EL',
  },
  HR: {
    component: HR,
    code: '385',
    prefix: 'HR',
  },
  HU: {
    component: HU,
    code: '36',
    prefix: 'HU',
  },
  IE: {
    component: IE,
    code: '353',
    prefix: 'IE',
  },
  IT: {
    component: IT,
    code: '39',
    prefix: 'IT',
  },
  LT: {
    component: LT,
    code: '370',
    prefix: 'LT',
  },
  LU: {
    component: LU,
    code: '352',
    prefix: 'LU',
  },
  LV: {
    component: LV,
    code: '371',
    prefix: 'LV',
  },
  MT: {
    component: MT,
    code: '356',
    prefix: 'MT',
  },
  NL: {
    component: NL,
    code: '31',
    prefix: 'NL',
  },
  PL: {
    component: PL,
    code: '48',
    prefix: 'PL',
  },
  PT: {
    component: PT,
    code: '351',
    prefix: 'PT',
  },
  RO: {
    component: RO,
    code: '40',
    prefix: 'RO',
  },
  SE: {
    component: SE,
    code: '46',
    prefix: 'SE',
  },
  SI: {
    component: SI,
    code: '386',
    prefix: 'SI',
  },
  SK: {
    component: SK,
    code: '421',
    prefix: 'SK',
  },
});
